// src/data/articleCategories.js
export const ARTICLE_CATEGORIES = [
  { key: "technology", label: "Technology" },
  { key: "research", label: "Research" },
  { key: "community", label: "Community" },
  { key: "business", label: "Business" },
  { key: "lifestyle", label: "Lifestyle" },
];


export const CATEGORY_KEYS = new Set(ARTICLE_CATEGORIES.map((c) => c.key));
export const CATEGORY_LABEL_BY_KEY = Object.fromEntries(
  ARTICLE_CATEGORIES.map((c) => [c.key, c.label])
);

//palettes (category-based)
export const CATEGORY_PALETTES = {
  technology: ["#6f53d5", "#14b8a6", "#ff4032"],
  research: ["#14b8a6", "#6f53d5", "#f3b640"],
  community: ["#ff4032", "#6f53d5", "#14b8a6"],
  business: ["#f3b640", "#6f53d5", "#4ec38aff"],
  lifestyle: ["#6f53d5", "#f3b640", "#14b8a6"],
};


// ✅ Pre-defined topics (keys + labels)
export const ARTICLE_TOPICS = [
  { key: "society", label: "Society" },
  { key: "politics", label: "Politics" },
  { key: "travel", label: "Travel" },
  { key: "well-being", label: "Well-being" },
  { key: "learning", label: "Learning" },
  { key: "tech", label: "Tech" },
  { key: "entrepreneurship", label: "Entrepreneurship" },
];


// Optional tag suggestions per category (for seeding / consistency)
export const CATEGORY_TAGS = {
  technology: ["ai", "frontend", "react", "performance", "ux"],
  research: ["papers", "experiments", "methods", "results"],
  community: ["events", "collaboration", "open-source", "mentorship"],
  business: ["strategy", "product", "growth", "case-study"],
  lifestyle: ["travel", "habits", "learning", "culture"],
};
